import React, { useEffect, useState } from "react";
import { getAuditLogs } from "../api"; 
import { toast } from "react-toastify";

const AuditDashboardPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filter State
  const [filters, setFilters] = useState({
    actor: "",
    action: "",
    entity: "",
    ip: "", // ✅ NEW: Added IP filter state
    details: "",
    date: ""
  });

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = () => {
    getAuditLogs()
      .then((res) => {
        setLogs(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching audit logs:", err);
        toast.error("Failed to load audit logs");
        setLoading(false);
      });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const filteredLogs = logs.filter(log => {
    const actorStr = log.actorName 
      ? log.actorName.toLowerCase() 
      : (log.actor_user_id ? log.actor_user_id.toString() : "system");
      
    const actionStr = log.action ? log.action.toLowerCase() : "";
    const entityStr = log.entity ? log.entity.toLowerCase() : "";
    // ✅ NEW: IP Filter Logic
    const ipStr = log.ip ? log.ip.toLowerCase() : "";
    const metaStr = log.meta ? log.meta.toLowerCase() : "";
    const dateStr = log.created_at ? new Date(log.created_at).toLocaleString().toLowerCase() : "";

    return (
      actorStr.includes(filters.actor.toLowerCase()) &&
      actionStr.includes(filters.action.toLowerCase()) &&
      entityStr.includes(filters.entity.toLowerCase()) &&
      ipStr.includes(filters.ip.toLowerCase()) && // ✅ Apply IP filter
      metaStr.includes(filters.details.toLowerCase()) &&
      dateStr.includes(filters.date.toLowerCase())
    );
  });

  return (
    <div className="container-fluid mt-4">
      <div className="card shadow-sm">
        <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
          <h4 className="mb-0">Audit Dashboard</h4>
          <span className="badge badge-light text-dark">Total Logs: {filteredLogs.length}</span>
        </div>
        <div className="card-body p-0">
          {loading ? (
            <div className="p-4 text-center">Loading logs...</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-hover mb-0 table-bordered">
                <thead className="thead-light">
                  <tr className="bg-white">
                    <th style={{minWidth: '150px'}}>
                      <input type="text" className="form-control form-control-sm" placeholder="Filter Actor..." name="actor" value={filters.actor} onChange={handleFilterChange} />
                    </th>
                    <th style={{minWidth: '120px'}}>
                      <input type="text" className="form-control form-control-sm" placeholder="Filter Action..." name="action" value={filters.action} onChange={handleFilterChange} />
                    </th>
                    <th style={{minWidth: '150px'}}>
                        <input type="text" className="form-control form-control-sm" placeholder="Filter Entity..." name="entity" value={filters.entity} onChange={handleFilterChange} />
                    </th>
                    {/* ✅ NEW: IP Filter Input */}
                    <th style={{minWidth: '130px'}}>
                        <input type="text" className="form-control form-control-sm" placeholder="Filter IP..." name="ip" value={filters.ip} onChange={handleFilterChange} />
                    </th>
                    <th>
                        <input type="text" className="form-control form-control-sm" placeholder="Search Details..." name="details" value={filters.details} onChange={handleFilterChange} />
                    </th>
                    <th style={{minWidth: '180px'}}>
                        <input type="text" className="form-control form-control-sm" placeholder="Filter Date..." name="date" value={filters.date} onChange={handleFilterChange} />
                    </th>
                  </tr>
                  <tr>
                    <th>Actor</th>
                    <th>Action</th>
                    <th>Entity</th>
                    {/* ✅ NEW: IP Column Header */}
                    <th>IP Address</th>
                    <th>Details</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredLogs.length > 0 ? (
                    filteredLogs.map((log) => (
                      <tr key={log.id}>
                        <td>
                          {log.actorName ? (
                              <div className="d-flex flex-column">
                                <span className="font-weight-bold text-primary">{log.actorName}</span>
                                <small className="text-muted" style={{fontSize: '0.75rem'}}>ID: {log.actor_user_id}</small>
                              </div>
                            ) : (
                              <span className={`badge ${log.actor_user_id ? 'badge-info' : 'badge-secondary'}`}>
                                {log.actor_user_id ? `User: ${log.actor_user_id}` : "System"}
                              </span>
                            )}
                        </td>
                        <td className="font-weight-bold text-uppercase" style={{fontSize: '0.9rem'}}>
                          {log.action}
                        </td>
                        <td>
                            {log.entity} <small className="text-muted">(#{log.entity_id})</small>
                        </td>
                        
                        {/* ✅ NEW: Display IP Address */}
                        <td className="text-monospace" style={{fontSize: '0.85rem'}}>
                            {log.ip || <span className="text-muted">-</span>}
                        </td>

                        <td style={{ maxWidth: "350px", wordWrap: "break-word", fontSize: "0.85rem" }}>
                            <code className="text-muted">{log.meta}</code>
                        </td>
                        <td style={{fontSize: '0.9rem'}}>
                          {new Date(log.created_at).toLocaleString()}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      {/* ✅ UPDATED: Increased colSpan to 6 */}
                      <td colSpan="6" className="text-center py-4">
                        No logs match your filters.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuditDashboardPage;